export default __webpack_public_path__ + "static/media/domain_verification_default.b576b853.svg";